/* Clarity is the sole behavioral recorder; Shopify app pixels own ecommerce.
 * Existing project, no Admin access, no customer IDs or custom field values.
 * Shopify Customer Privacy is authoritative; never trust the legacy UI cache.
 */
(function () {
  'use strict';
  if (window.__yojoBehavior) return;
  window.__yojoBehavior = true;
  var shopify = window.Shopify || {};
  var url = new URL(window.location.href);
  var path = url.pathname;
  // Test and agent visits are flagged once and stay flagged for the browser
  // session: `yojo_analytics=off` keeps Clarity off on every later page, and a
  // QA marker (utm_source=yojo-qa, the measurement test, or the test helper's
  // sessionStorage flag) tags any recording so it can be filtered out.
  function sessionFlag(name, on) {
    try {
      if (on) sessionStorage.setItem(name, '1');
      return sessionStorage.getItem(name) === '1';
    } catch (_) { return !!on; }
  }
  var analyticsOff = sessionFlag('yojo_analytics_off', url.searchParams.get('yojo_analytics') === 'off');
  var qaVisit = sessionFlag('yojo_qa', url.searchParams.get('utm_source') === 'yojo-qa' ||
    url.searchParams.get('yojo_measurement_test') === '1');
  // Preview URLs can lose their query string: check Shopify's actual role too.
  if (!shopify.theme || shopify.theme.role !== 'main' || shopify.designMode ||
      url.searchParams.has('preview_theme_id') || analyticsOff ||
      /\/(account|checkouts?|orders|thank_you|search)(\/|$)/i.test(path) ||
      /\/pages\/(contact|privacy|terms)/i.test(path)) return;
  // Never record a page carrying free-text search, account tokens or contact data.
  for (var pair of url.searchParams) {
    if (/^(q|email|phone|address|name|first_name|last_name|token|key|code)$/i.test(pair[0]) ||
        /@|%40/.test(pair[1])) return;
  }

  var active = false;
  var installed = false;
  var stopped = false;
  var lastConsent = '';
  var PROJECT = 'x9z4t4gzup';

  function consent() {
    try {
      var cp = shopify.customerPrivacy;
      return {
        analytics: !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()),
        ads: !!(cp && cp.marketingAllowed && cp.marketingAllowed() &&
          cp.saleOfDataAllowed && cp.saleOfDataAllowed())
      };
    } catch (_) { return { analytics: false, ads: false }; }
  }
  function call() {
    try { if (typeof window.clarity === 'function') window.clarity.apply(window, arguments); } catch (_) {}
  }
  function event(name) {
    if (active && consent().analytics) call('event', name);
  }
  function clearClarityCookies() {
    // Only Clarity cookies. Covers host and parent scope after a fast withdrawal.
    ['_clck', '_clsk'].forEach(function (name) {
      ['', '; domain=' + url.hostname, '; domain=.' + url.hostname].forEach(function (domain) {
        document.cookie = name + '=; Max-Age=0; path=/' + domain + '; SameSite=Lax';
      });
    });
  }
  function sync() {
    var state = consent();
    if (!state.analytics) {
      active = false;
      if (installed && !stopped) {
        call('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
        call('stop');
        clearClarityCookies();
        stopped = true;
        lastConsent = '';
      }
      return;
    }
    // Do not restart a stopped recorder mid-page: a fresh navigation can start it.
    if (stopped) return;
    if (!installed) {
      // Respect another installation if an app is enabled later; never double-load.
      if (window.clarity || document.querySelector('script[src*="clarity.ms/tag/"]')) return;
      installed = true;
      // Mask the whole DOM before the remote code executes, including dynamic forms.
      document.documentElement.setAttribute('data-clarity-mask', 'true');
      window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      call('consentv2', {
        analytics_Storage: 'granted', ad_Storage: state.ads ? 'granted' : 'denied'
      });
      lastConsent = String(state.ads);
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + PROJECT;
      script.onload = sync;
      script.onerror = function () { active = false; };
      document.head.appendChild(script);
      var pageType = path === '/' ? 'home' : path.split('/')[1];
      if (['home', 'products', 'collections', 'cart', 'pages', 'blogs'].indexOf(pageType) < 0) pageType = 'other';
      call('set', 'yojo_page_type', pageType);
      call('set', 'yojo_environment', 'production');
      call('set', 'yojo_measurement_version', '2026-09-11');
      if (qaVisit) call('set', 'yojo_qa', 'true');
    }
    if (lastConsent !== String(state.ads)) {
      call('consentv2', { analytics_Storage: 'granted', ad_Storage: state.ads ? 'granted' : 'denied' });
      lastConsent = String(state.ads);
    }
    active = true;
  }

  document.addEventListener('visitorConsentCollected', sync);
  if (shopify.customerPrivacy) sync();
  else if (typeof shopify.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) sync();
    });
  }

  // A deliberately small vocabulary. Names carry no text, URLs, IDs or prices.
  document.addEventListener('cart:add', function () { event('yojo_cart_add_success'); });
  // 2026-10-14 gift ladder (M1): gift added / removed / charged-and-removed /
  // sold out / add failed / restored, by step number only (no text or prices).
  document.addEventListener('yojo:ladder', function (ev) {
    var d = (ev && ev.detail) || {};
    var allowed = ['gift_added', 'gift_removed', 'gift_charged_removed', 'gift_sold_out', 'gift_add_failed', 'gift_restored'];
    if (allowed.indexOf(d.action) === -1) return;
    event('yojo_ladder_' + d.action + (d.step ? '_' + String(d.step).replace(/\D/g, '') : ''));
  });
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t || !ev.isTrusted) return;
    if (t.closest('a[href*="/products/"]')) event('yojo_product_link');
    if (t.closest('[name="checkout"], #CheckOut, a[href^="/checkout"]')) event('yojo_checkout_intent');
    if (t.closest('[data-yqa-close]')) event('yojo_pack_picker_close');
  }, true);
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !ev.isTrusted) return;
    if (t.name === 'sort_by') event('yojo_sort_change');
    else if (t.name && t.name.indexOf('filter.') === 0) event('yojo_filter_change');
    else if (t.closest && t.closest('.yojo-pdp, #yojo-quick-add-portal') && t.matches('input[type="radio"], select')) event('yojo_pack_change');
  }, true);
  document.addEventListener('submit', function (ev) {
    if (ev.target.matches && ev.target.matches('form[action*="/search"]')) event('yojo_search_submit');
  }, true);

  function observeDrawer() {
    var drawer = document.getElementById('site-cart-sidebar');
    if (!drawer || typeof MutationObserver !== 'function') return;
    var open = drawer.classList.contains('sidebar--opened');
    new MutationObserver(function () {
      var next = drawer.classList.contains('sidebar--opened');
      if (next !== open) {
        open = next;
        event(next ? 'yojo_cart_drawer_open' : 'yojo_cart_drawer_close');
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeDrawer, { once: true });
  else observeDrawer();
})();
